<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'carWashCentreManagement' }">洗车点管理</el-breadcrumb-item>
        <el-breadcrumb-item>编辑洗车点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div>
        <el-form v-loading="formLoading" ref="carWashCentre" :model="listParams" :rules="checkListParams" label-width="150px">
          <el-form-item label="洗车点名称：" prop="name">
            {{ listParams.name }}
          </el-form-item>

          <el-form-item label="洗车点地址：" prop="address">
            {{ listParams.address }}
          </el-form-item>

          <el-form-item label="联系电话：" prop="mobile">
            <el-input size="small" placeholder="请填写联系电话" v-model="listParams.mobile"> </el-input>
          </el-form-item>

          <el-form-item label="洗车点图片：" prop="pictures">
            <div class="upload-thumbnail-img" :loading="uploading">
              <i class="el-icon-circle-plus-outline upload-icon"></i>
              <input type="file" class="hidden-upload" @change="doUpload" id="uploadDom" />
            </div>
            <div class="wrap-thumbnail-img" v-if="listParams.pictures.length > 0">
              <div class="thumbnail-img" v-for="(item, index) in listParams.pictures" :key="index">
                <div class="combined-img">
                  <img :src="item" alt="" class="thumbnail-img-wrapped" :key="index" />
                  <div class="hover-img">
                    <i class="el-icon-circle-close-outline close-btn" @click="deleteImg(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label=" ">
            <div class="align-center mgt30">
              <el-button size="small" type="primary" :disabled="isDisabled" @click="saveEdit('carWashCentre')">
                保存
              </el-button>
              <el-button size="small" @click="backToListPage">
                返回
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  components: {},
  data() {
    return {
      carWashId: "",
      id: "",
      formLoading: false,
      listParams: {
        name: "",
        address: "",
        mobile: "",
        pictures: []
      },
      checkListParams: {
        name: [{ required: true, message: "请填写洗车点名称", trigger: "blur" }],
        address: [{ required: true, message: "请填写洗车点地址", trigger: "blur" }],
        mobile: [{ required: true, message: "请填写联系电话", trigger: "blur" }],
        pictures: [
          {
            required: true,
            message: "请至少上传一张洗车点图片",
            trigger: "change"
          }
        ]
      },
      uploading: false,
      isDisabled: false
    };
  },
  mounted() {
    this.carWashId = this.$route.params.carWashId;
    this.loadDetailData(this.$route.query.id);
  },
  methods: {
    /**
     * 加载详情页数据
     */
    loadDetailData(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/carwash/detail",
        method: "GET",
        params: {
          id: id,
          carWashId: this.carWashId
        }
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.listParams, res.body.data);
            this.formLoading = false;
          } else {

            this.formLoading = false;
          }
        })
        .catch((err) => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 上传图片
     */
    doUpload() {
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const file = files[0];
      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/good-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then((res) => {
          this.uploading = false;
          this.listParams.pictures.push(res.data.data);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除图片
     * @param index
     */
    deleteImg(index) {
      this.listParams.pictures.splice(index, 1);
    },
    /**
     * 保存修改的内容
     * @param name
     */
    saveEdit(name) {
      this.isDisabled = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          const bodyParams = Object.assign({}, this.listParams, {
            carWashId: this.carWashId
          });
          this.$http({
            url: global.apiUrl + "/carwash/update",
            method: "PUT",
            body: bodyParams
          })
            .then((res) => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.$message.success(res.body.info);
              } else {
                this.isDisabled = false;
              }
            })
            .catch((err) => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 返回洗车点列表页
     */
    backToListPage() {
      this.$router.push({
        name: "carWashCentreManagement"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.hx-form-container {
  .wang-editor-style {
    height: 600px;
    .wang-editor-body {
      height: 540px;
    }
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
